export default function useResponse(response) {
  return {
    ...response.data,
    pagination: {
      perPage: response.data?.limit,
      page: response.data?.current_page,
      totalPage: response?.data.pages_count,
    },
    documents: response.data.documents,
  }
}
